import React from 'react'

const ForecastSection = (props) => {
  return (
    <article className="cards">
      {props.children}
    </article>
  
  )}

export default ForecastSection
